import React from 'react';
import IconButton from '@mui/material/IconButton';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import DeleteOutlineTwoToneIcon from '@mui/icons-material/DeleteOutlineTwoTone';
import { Box } from '@mui/material';
import { ThumbnailProps } from './media-props';

const Thumbnail: React.FC<ThumbnailProps> = ({
  url,
  image,
  mediaID,
  allowDeleting = false,
  altText,
  children,
  handleDeleteRequest = () => null,
  selectMedia = () => null,
  sx,
  imgStyles,
}: ThumbnailProps) => (
  <>
    {children || (
      <ImageListItem
        sx={sx}
        key={url}
        onClick={(e) => {
          e.preventDefault();
          selectMedia(image!);
        }}
      >
        <Box
          component="img"
          src={url}
          srcSet={url}
          loading="lazy"
          alt={altText}
          style={imgStyles}
        />
        <ImageListItemBar
          sx={{ background: 'transparent' }}
          position="top"
          actionIcon={allowDeleting && (
            <IconButton
              size="small"
              sx={{
                borderRadius: '4px',
                background: 'rgba(255, 255, 255, 0.7)',
                mt: '11px',
                mr: '9px',
                '&:hover': { background: '#EEEEEE' },
              }}
              title="Delete this file"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleDeleteRequest(mediaID || '');
              }}
            >
              <DeleteOutlineTwoToneIcon />
            </IconButton>
          )}
          actionPosition="right"
        />
      </ImageListItem>
    )}
  </>
);

export default Thumbnail;
